module.exports = __webpack_public_path__ + "static/elevatewomen-5ae97cc74c91a3d2e85bbb5b6c0f07c4.jpeg";